import { userSilentApi as silentApi } from "../../utils/apiInstances";

// Function to get shop
export const handleGetShop = async <TData = unknown>(params: Record<string, unknown> = {}) => {
    try {
        const query = Object.entries(params)
            .filter(
                ([, value]) => value !== undefined && value !== null && value !== ""
            )
            .map(
                ([key, value]) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
            )
            .join("&");

        const endpoint = `/user/shop${query ? `?${query}` : ""}`;
        const response = await silentApi<TData>("GET", endpoint);
        return response;
    } catch {
        return undefined;
    }
};

//funtion to initialize checckout
export const handleUserInitializeCheckout = async (
    userData: unknown,
    onSuccess: (res: unknown) => void,
    onError?: (err: unknown) => void
) => {
    try {
        const response = await silentApi("POST", "/user/shop", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};
